

import state from './modulePenyaluranState.js'
import mutations from './modulePenyaluranMutations.js'
import actions from './modulePenyaluranActions.js'
import getters from './modulePenyaluranGetters.js'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
